<template>
    <div class="fullheight-section">
      <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="container">
          <div class="navbar-brand">
            <a class="navbar-item" style="padding-top: 10px">
              <img
                src="../../src/assets/img/cardiff-white-text-only.png"
                id="logo"
                height="28"
                alt="cardiff logo"
              />
            </a>
          </div>
        </div>
      </nav>
      <div class="container is-fluid fullheight-section" id="app-renewal-container">
        <div class="columns fullheight-section is-centered">
          <div class="column" id="app-column-renewal">
            <transition name="slide" mode="out-in">
              <RenewalApplyLoading
                v-if="page == 0"
                key="p0"
                @next="incrementPage"
                :link="$route.params.code"
              />
              <RenewalApplyForm
                v-if="page == 1"
                key="p0"
                @next="incrementPage"
                :link="$route.params.code"
              />
              <RenewalApplyVerification
                v-if="page == 2"
                key="p0"
                @next="incrementPage"
                message="message loading"
                :sfoppid="model.sfoppid"
              />
              <Plaid
                v-if="page == 3"
                key="p2"
                @next="incrementPage"
                api="connect-bank-renewal"
                :link="model.sfoppid"
                redirect_url="connect-bank-renewal"
              />
              <RenewalBanksUpload
                v-if="page == 4"
                key="p0"
                @next="incrementPage"
                :link="$route.params.code"
              />
              <RenewalApplyFinish
                v-if="page == 5"
                key="p3"
                @next="incrementPage"
                :completed_plaid="completed_plaid"
                @back="page--"
              />
            </transition>
          </div>
        </div>
      </div>
      <footer class="footer" style="margin-top: 60px" v-if="page != 7">
        <div class="content has-text-centered">
          <img
              src="../../src/assets/img/bbb.png"
              style="max-width: 100px; margin-right: 10px; margin-left: 10px"
              loading="lazy"
              alt="bbb logo"
            />
            <img
              src="../../src/assets/img/ssl.png"
              style="max-width: 100px; margin-right: 10px"
              loading="lazy"
              alt="SSL logo"
            />
          <p style="font-size: 0.675em; margin-top: 10px">
            © 2025 Cardiff, Inc
          </p>
        </div>
      </footer>
      <div v-if="!prod" id="stagingmenu">
      <div style="display: flex">
        <div style="flex: 1; padding-left: 10px">
          <p
            style="
              font-weight: bold;
              font-variant: all-small-caps;
              margin-bottom: 0px;
              text-align: center;
            "
          >
            IFF Staging Menu ({{
              model.sfleadid ? "Lead ID:" + model.sfleadid : "NOT COMMITTED"
            }})
          </p>
          <div
            style="
              flex: 1;
              display: flex;
              text-align: center;
              align-items: center;
              margin-bottom: 10px;
            "
          >
            <div
              style="
                flex: 1 1 auto;
                cursor: pointer;
                margin: 0 auto;
                max-width: 40px;
                background-color: #276cda;
                border-color: transparent;
                color: #fff;
                border-radius: 5px;
                padding: 5px;
              "
              @click="page > 0 ? page-- : console.log('cant')"
            >
              -
            </div>
            <div style="text-align: center; margin-bottom: 5px">
              Page {{ page }}/{{ maxPage }} ({{
                isMobile() ? "Mobile" : "Desktop"
              }})
            </div>
            <div
              style="
                flex: 1 1 auto;
                cursor: pointer;
                margin: 0 auto;
                max-width: 40px;
                background-color: #276cda;
                border-color: transparent;
                color: #fff;
                border-radius: 5px;
                padding: 5px;
              "
              @click="page < maxPage ? page++ : console.log('cant')"
            >
              +
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </template>
  <script>
  import {
    RenewalApplyLoading,
    RenewalApplyForm,
    RenewalApplyVerification,
    RenewalBanksUpload,
    RenewalApplyFinish,
    Plaid
  } from "@/components/apply/pages";
  import { build } from "@/tools/modelBuilder";
  import MyUtils from "@/utils/MyUtils";
  // import RenewalApplyVerification from "./apply/pages/RenewalApplyVerification.vue";

  let location = window.location.href;
  let validate = location.indexOf("://cardiff") > -1 || location.indexOf("www.cardiff") > -1;
  console.log("validate", validate);

  export default {
    name: "RenewalApply",
    components: {
        RenewalApplyLoading,
        RenewalApplyForm,
        RenewalBanksUpload,
        RenewalApplyVerification,
        RenewalApplyFinish,
        Plaid
    },
    data() {
      return {
        page: 0,
        demo: false,
        maxPage: 5,
        scrolled: false,
        loading: false,
        prod: validate,
        model: {
          sf_account_id: null,
          sfoppid:null,
          campaign: '',
          source: '',
          medium: '',
          qs : '',
          rep: ''
         },
         completed_plaid: true,
         active_plaid_connections :0
      };
    },
    methods: {
      incrementPage: function (pageData) {
        console.log("page:", this.page);
        var self = this;
        console.log(pageData);

        if (pageData && pageData.inputs && pageData.inputs.completed_plaid) {
          console.log("completed plaid: " + pageData.inputs.completed_plaid);
          this.completed_plaid = pageData.inputs.completed_plaid;
        }

        this.validate();
        build(this.model, pageData);
        //post from page 0
        if (this.page == 0) {
          // setWithExpiry("leadid", "", 1);
          console.log("page 1");
          $.ajax({
            type: "POST",
            url: "/api/rn/active-plaids/",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({
              model: self.model,
            }),
          })
          .done(function (response) {
            console.log(response);
            if (response.active) {
              self.active_plaid_connections = response.active;
              console.log("setting active_plaid_connections in model", response.active);
            //   self.model.sfoppid = response.oppid;
            //   //save to local storage
              MyUtils.setWithExpiry("active_plaid_connections", response.active, 900000);
            }
          })
          .fail(function (err) {
            console.log(err.responseText);
            self.invalid = true;
          });
        }
        if (this.page == 1) {
          console.log("sending form:");
          console.log(self.model);
          $.ajax({
            type: "POST",
            url: "/api/rn/apply-form/",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({
              model: self.model,
            }),
          })
          .done(function (response) {
            console.log(response);
            if (response.oppid) {
              console.log("setting oppid in model", response.oppid);
              self.model.sfoppid = response.oppid;
              //save to local storage
              MyUtils.setWithExpiry("oppid", response.oppid, 900000);
            }
          })
          .fail(function (err) {
            console.log(err.responseText);
            self.invalid = true;
          });
        }
        
        console.log('active plaids!', self.active_plaid_connections)
        if(this.page == 1 && self.active_plaid_connections > 0){
          this.page = 3; //move to next page
        }
        if(this.page == 2 ){
          console.log('verify bank plaid plaid!!')
          
        }
        if(this.page == 3 ){
          console.log('plaid finished!!');
          if(this.isMobile()){
            this.page = 4;
          }
        }
        if(this.page == 4 ){
          console.log('file upload!!')
        }
        this.page++;
        window.scrollTo(0, 0);
      },
      isMobile: function () {
        var check = false;
        (function (a) {
          if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
              a
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
              a.substr(0, 4)
            )
          )
            check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
      },
      validate: function () {
        console.log(this.$route.params.sfaccount);
      },
    },
    created : function(){
      let self = this;
      if (
        self.$route.params &&
        self.$route.params.sfaccount
      ) {
        let account_id = self.$route.params.sfaccount;
        setTimeout(function(){
          console.log('verifying link!');
        $.ajax({
            type: "POST",
            url: "/api/rn/verify-link",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({ link: account_id }),
          })
            .done(function (response) {
              console.log("verify link response");
              console.log(response);
              if (response.valid && response.valid == true) {
                MyUtils.setWithExpiry("account_id", response.account_id, 900000);
                self.model.sf_account_id = response.account_id;
                MyUtils.setWithExpiry("company_name", response.company_name, 900000);
                // self.next();
                // self.invalid = false;
              } else {
                MyUtils.setWithExpiry("account_id", null, 1);
                MyUtils.setWithExpiry("company_name", null, 1);
                // self.next();
                // self.invalid = true;
              }
              self.incrementPage({})
            })
            .fail(function (err) {
              console.log("fail");
              console.log(err.responseText);
              // self.invalid = true;
            });
      },1000);
      }
  
      const account_id = MyUtils.getWithExpiry("account_id");
      console.log('account-id from memory:', account_id);
      if (account_id) {
        self.model.sf_account_id = account_id;
      }
    },
    mounted: function () {
    // attentive UTMS
      let self = this;
      self.model.medium = "";
      self.model.source = "";
      self.model.campaign = "";

      let url_query = "";
      if (self.$route.query && self.$route.query != "") {
        url_query = self.$route.query;
      }
      console.log("url query: ", url_query);
      if (url_query &&  url_query.utm_campaign && url_query.utm_campaign.length !== 0) {
        self.model.campaign = url_query.utm_campaign;
      }
      if (url_query && url_query.utm_medium && url_query.utm_medium.length !== 0) {
        self.model.medium = url_query.utm_medium;
      }
      if (url_query && url_query.utm_source && url_query.utm_source.length !== 0) {
        self.model.source = url_query.utm_source;
      }
      if (url_query && url_query.utm_rep && url_query.utm_rep.length !== 0) {
        self.model.rep = url_query.utm_rep;
      }
    },
  };
  </script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar .navbar-brand {
  text-align: center;
  display: block;
  width: 100%;
}

.navbar .navbar-brand > .navbar-item,
.navbar .navbar-brand .navbar-link {
  display: inline-block;
}
#app-column-renewal{
  max-width: 700px;
  padding-left: 20px;
  padding-right: 20px;
}
/* .continue-button {
  color: #FFF;
  text-align: center;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  height: 64px;
} */
@media screen and (min-width: 767px), print {
  .mobile-only {
    display: none;
  }
  .fullheight-section {
    height: 100%;
  }
  #app-column-renewal {
    padding: 50px 50px;
  }
}

@media screen and (max-width: 768px) {
  #cardiff-column {
    display: none;
  }
  #app-column-renewal {
    min-height: 50vh;
    padding-top: 50px;
  }
}

#cardiff-column {
  background: #f1f1f1;
  z-index: 1;
  padding-top: 100px;
  max-width: 280px;
}

#logo {
  /* max-width: 50%; */
  margin: auto;
  display: block;
  /* margin-top: 10px; */
  /* margin-bottom: 10px; */
}

.next-button {
  margin-top: 10px;
}

.columns {
  margin-left: 0;
  margin-right: 0;
}

.no-margin {
  margin-bottom: 0px !important;
}

#app-renewal-container{
  /* background: linear-gradient(235deg, rgba(0, 100, 221, 0.20) 0%, rgba(255, 255, 255, 0.00) 100%);
  flex-shrink: 0; */
  /* max-height: none; */
  background: url("https://cardiff.b-cdn.net/img/gradient-desktop2.png");
  
  background-repeat: no-repeat;
  margin-left: 0;
  /* background-size: contain; */
  background-size: cover;
  padding-top: 32px;
  min-height: 100%;
}
@media (max-width: 47.999em) {
  #app-renewal-container{
    background: url("https://cardiff.b-cdn.net/img/gradient-mobile-2.png");
    background-repeat: no-repeat;
    margin-left: 0;
    background-size: contain;
    padding-right: 24px;
    padding-left: 24px;
    padding-top: 20px;
  }
  #app-column-renewal{
    margin-top: 0;
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
  }
}

#stagingmenu {
  position: fixed;
  width: 100%;
  bottom: 0;
  background: #ecf3ff;
  opacity: 0.3;
  z-index: 1;
  transition: all 0.3s;
}

#stagingmenu:hover {
  opacity: 1;
}
</style>
